import { useQuery } from '@tanstack/react-query';
import recoveryMessagesService from 'v2/services/recoveryMessages';

export function useListRecoveryMessages(productId: number) {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['recoveryMessages', productId],
    queryFn: () => recoveryMessagesService.list(productId),
    select: response => (Array.isArray(response?.data) ? response.data : Array.isArray(response) ? response : []),
    enabled: !!productId
  });

  return { data: data ?? [], isLoading, error, refetch };
}
